import { render, staticRenderFns } from "./VerticalFilter.vue?vue&type=template&id=6486efa7&scoped=true&"
import script from "./VerticalFilter.vue?vue&type=script&lang=js&"
export * from "./VerticalFilter.vue?vue&type=script&lang=js&"
import style0 from "./VerticalFilter.vue?vue&type=style&index=0&id=6486efa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6486efa7",
  null
  
)

export default component.exports